import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { MDBBtn } from "mdb-react-ui-kit";
// config
import configData from "../../config/config.json";
// style
import "./registery.css";
// components
import MetaTagsBusinessOwners from "../../components/meta-tags-seo/MetaTagsBusinessOwners";
import AlertSuccess from "../../components/AlertSuccess/AlertSuccess";
// img
import emailImg from "../../images/registery/email box.svg";

function EmailRegisteryPage(props) {
  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  const { state } = props.location;

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-email",
  };

  useEffect(() => {
    axios
      .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
        headers: headerMeta,
      })
      .then((response) => {
        if (response.data.isSuccess) {
          setMTagsCome(true);
          setMetaData(response.data.data);
        }
      })
      .catch((error) => {
        // alert(error);
      });
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 3000);
  };

  const [disable, setDisable] = useState(false);

  const resendEmail = () => {
    if (!disable) {
      setDisable(true);

      const dataPost = {
        ownerId: getCookie("OwnerIdConfirm"),
        // email: "null",
        email: state,
      };

      axios
        .post(
          configData.API_DOMAIN + "/api/v1/BusinessOwners/resend-email",
          dataPost,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
            },
          }
        )
        .then((response) => {
          setDisable(false);
          if (response.data.isSuccess) {
            // success
            alertHandeler();
          }
        })
        .catch((error) => {
          // alert(error);
          setDisable(false);
        });
    }
  };

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      <div className="registery-bg">
        <object
          data={emailImg}
          alt={"welcome image"}
          className="registery-welcome-img2"
        ></object>
        {/* <img
          src={welImg}
          alt="welcome image"
          className="registery-welcome-img"
        /> */}
        <div className="w-100 position-relative">
          <div className="registery-cir-bg"></div>
          <div className="registery-rec-bg">
            <p className="registery-welcome-text2">
              از این‌که به گیشنیز پیوستید ممنونیم.
              <br />
              لطفا ثبت نام خود را از طریق لینک تاییدی
              <br />
              که به ایمیل شما ارسال شده است، کامل کنید.
            </p>

            <div className="d-flex justify-content-center">
              <p className="registry-resend-email">ایمیل را دریافت نکرده‌ام</p>
            </div>
            <div className="d-flex justify-content-center">
              <MDBBtn
                disabled={disable}
                onClick={resendEmail}
                className="registry-resend-email-btn"
              >
                ارسال مجدد
              </MDBBtn>
            </div>
          </div>
        </div>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={"ایمیل جدید برای شما ارسال شد"}
        />
      </div>
    </>
  );
}

export default EmailRegisteryPage;
